module.exports = __webpack_public_path__ + "img/customer-journey.aca400e2.jpg";